
<template>
  <div class="s4s-page" >
    <div v-if="carList.length == 0" class="s4s-car-info" >
      <div class="s4s-form-body">
        <div class="s4s-title s4s-form-title">
          <div style="display:flex;line-height: 30px;width:50%;">添加车辆查违章</div>
          <div style="display:flex;align-item:center;width:50%;justify-content: center;">
            <div class="s4s-title-icon" >快速查询</div>
            <div class="s4s-title-icon1"   v-if="['cmbchange','cmbapp'].indexOf(advertisingShow.channel) == -1">轻松代办</div>
          </div>
        </div>
        <div class="s4s-uplaod">
          <div class="s4s-uplaod-content" bind:tap="chooseimg">
            <img class="s4s-uplaod-pic" src="../assets/icon/uploadPic.png"  />
            <span class="blue" >扫描行驶证</span>自动填写信息
          </div>
        </div>
        <div class="s4s-group" style="font-size:14px">
          <span class="s4s-group-tit">车辆类型</span>
          <select name="" id="">
            <option value="">214</option>
          </select>
        </div>
        <div :class="isCarnoTrue ? 's4s-group' : 's4s-group s4s-group-error'">
          <span class="s4s-group-tit">车牌号码</span>
          <div style="display: flex;align-items:center;overflow: hidden;width:160px;">
            <div class="s4s-sel-provice" style="float: left;" @click="selectProvice">
              <span>{{ provice }}</span>
              <div class="triangle-button"></div>
            </div>
            <input
              focus="focus1"
              style="span-transform:uppercase;"
              bindfocus="bindFocus"
              type="span"
              bindinput="bindNoInput"
              name="carno"
              maxlength="7"
              value="carno"
              placeholder="请输入车牌号码"
            />
          </div>
        </div>
        <div v-if="vinLength > 0"
          :class="isVinTrue ? 's4s-group' : 's4s-group s4s-group-error'"
        >
          <div class="s4s-group-tit">车架号码
          </div>
          <input
          type="span"
          style="span-transform:uppercase;"
          bindfocus="bindFocus" bindinput="bindVinInput" name="vin" value="vin"
          placeholder="vinPlaceholder" focus="focus2"/>
          <span class="s4s-help" bind:tap="classDetail"></span>
        </div>
        <div v-if="engineNoLength > 0"
          :class="isEngineTrue ? 's4s-group' : 's4s-group s4s-group-error'"
        >
          <div class="s4s-group-tit">发动机号
          </div>
          <input type="span"  style="span-transform:uppercase;"
          bindinput="bindEnInput" name="engion" bindfocus="bindFocus"
          value="engion" placeholder="enginePlaceholder"/>
            <span class="s4s-help" bind:tap="engineDetail"></span>
        </div>
      </div>
      <div v-if="error" class="s4s-error">{{error}}</div>
      <button type="primary" class="s4s-btn"
      bind:tap="formSubmit" hover-class="defaultTap"
      :style="{backgroundImage:advertisingShow.backgroundImage}"> 查询违章 </button>
      <!-- <copyright-component name="copyright"></copyright-component> -->
      <div class="s4s-copyright">
        <div>本服务由 <span @click="gotoMys4s" class="blue">齐车大圣</span> 提供，客服电话：
          <a class="s4s-copyright-phone" href="tel://0571-26281166"  >0571-26281166</a>
        </div>
      </div>
      <div class="s4s-mask" bind:tap="closeMake" v-if="detail">
          <img src="src" mode="aspectFit" />
      </div>
    </div>
    <div v-else>
    </div>
    <!-- <div v-if="showCaptcha" class="captcha">
        <div class="s4s-mask" />
         <div class="captcha-container">
             <div class="captcha-title">请输入验证码</div>
             <img
              src="captchUrl"
              mode="aspectFit"
              style="width: 272px;height: 9px;"
              bindtap="getCaptcha"/>
            <div
              class="captcha-change"
              bindtap="getCaptcha">看不清？换一张</div>
            <div class="captcha-input-container" bindtap="foucsShowCaptcha">
                <div class="captcha-input"
                style="captchaFoucs?'border-color:#3A82FF':''"
                  v-for="item in captchValue"  >
                    {{item||''}}
                </div>
            </div>
            <div class="captcha-keyboard">
              <div class="captcha-key-list"  v-for="item in captchKeyArray" >
<button class="captcha-key" bindtap="onInputCaptcha" data-value="ele" v-for="ele in item" >
                  {{ele}}
                </button>
              </div>
              <div class="captcha-key-list">
                    <button class="captcha-key">

                  </button>
                  <button class="captcha-key" bindtap="onInputCaptcha" data-value="0">
                      0
                  </button>
                  <button class="captcha-key" bindtap="onInputCaptcha" data-value="'←'">
                      ←
                  </button>
              </div>
            </div>
        </div>
    </div> -->
  <!-- <div class="s4s-ad" v-if="data.length">
    <div class="s4s-ad-header">
      <div class="s4s-ad-line"></div>
      <div class="s4s-ad-header-content">猜你想看</div>
      <div class="s4s-ad-line"></div>
    </div>
    <div class="s4s-ad-list">
      <div class="s4s-ad-item"
       v-for="item in data" bind:tap="gotoNews" data-id="item.id" data-type="item.Type">
        <img class="s4s-ad-img"
         v-if="item.cover_url1&& item.cover_url1 !== 'None'" mode="aspectFill" src="item.cover_url1"
        />
        <div class="s4s-ad-content">
          <div class="s4s-ad-title">
            {{item.title}}
          </div>
          <div class="flex">
            <div class="s4s-ad-time flex-1">
              {{item.last_modify_time}}
            </div>
            <div v-if="item.Type===1" class="s4s-ad-time">
              <img src="../assets/icon/eye.png"
              style="width:17px;height:10px;margin-right:4px;"/> {{item.show_num}}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div> -->
  <Provice :show="showProvice"
  @on-status-change="onProviceStatusChange"
  @on-result-change="onProviceResultChange"  />
</div>
</template>
<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';
import Provice from '@/components/Provice.vue';
import advertisingShow from './../utils/advertising';

export default {
  name: 'illegal',
  components: {
    HelloWorld,
    Provice,
  },
  data() {
    return {
      provice: '浙',
      showProvice: false,
      detail: false,
      src: '',
      user: null,
      illegal: {},
      carList: [], // 设置车牌是否有列表项
      lists: [],
      carno: '',
      engion: '',
      vin: '',
      car: null,
      driveUrl: '',
      picList: [
        'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vi/vi_banner1.png',
        'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vi/vi_banner2.png',
      ],
      engineNoLength: 0,
      vinLength: 0,
      vinPlaceholder: '请输入完整的车架号',
      enginePlaceholder: '请输入完整的发动机号',
      focus1: false,
      focus2: false,
      selIndex: 0,
      action: '',
      alading: true, // 阿拉丁跳转标识
      // 当前轮播状态
      current: 0,
      showSelectedItem: false,
      selectedItem: {},
      error: '',
      isCarnoTrue: true,
      isVinTrue: true,
      isEngineTrue: true,
      showCaptcha: false,
      needCaptcha: false,
      captchUrl: '',
      captchKey: '',
      captchValue: ['', '', '', ''],
      captchKeyArray: [[1, 2, 3], [4, 5, 6], [7, 8, 9]],
      carTypeArray: [
        { name: '小型轿车', id: '02' },
        { name: '大型汽车', id: '01' },
        { name: '中国香港入境车', id: '26' },
        { name: '中国澳门入境车', id: '27' },
        { name: '新能源大车', id: '51' },
        { name: '新能源小车', id: '52' }],
      carTypeIndex: 0,
      // ad
      page: 0,
      data: [],
      loading: false,
      advertisingShow: advertisingShow(),
    };
  },
  watch: {
    provice(val) {
      this.$request('v3/violation/rule', {
        prefix: val,
      }).then((xhr, res) => {
        if (res.code === 20022) {
          return;
        }
        if (res.code >= 40000 && res.code < 50000) {
          return;
        }
        if (res.code === 0) {
          this.vinLength = res.data.vinLength;
          this.engineNoLength = res.data.engineNoLength;
        }
      });
    },
  },
  methods: {
    gotoMys4s() {
      // _czc.push(['_trackEvent', '齐车大圣', 'current=1', '','','']); //eslint-disable-line
      window.location.href = 'https://mys4s.cn/#/driver?current=1';
    },
    selectProvice() {
      this.showProvice = !this.showProvice;
    },
    onProviceStatusChange(val) {
      this.showProvice = val;
    },
    onProviceResultChange(val) {
      this.provice = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.s4s-page {
  // padding-bottom: 50px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}
.s4s-illegal-bg {
  background: #00a1ee url(../assets/icon/head_bg.png) no-repeat left bottom / 100%
    28px;
  width: 100%;
  height: 110px;
}

.s4s-form-title {
  display:flex;
  align-items: center;
}


.s4s-title-icon {
  font-size:11px;
  color:#fff;
  /* background-image: linear-gradient(-228deg, #67C7F7 2%, #388DF4 100%); */
  border-radius: 2px;
  display:inline-block;
  padding:0 5px;
  /* height: 18px; */
  border-radius: 20px;
  /* font-style: italic; */
  color: #3A82FF;
  border: .5px solid #3A82FF;
  padding: 4px 8px
  /* font-weight: 200; */
}
.s4s-title-icon1 {
  font-size:11px;
  color:#fff;
  /* background-image: linear-gradient(-228deg, #67C7F7 2%, #388DF4 100%); */
  border-radius: 2px;
  display:inline-block;
  padding:0 5px;
  /* height: 18px; */
  border-radius: 20px;
  /* font-style: italic; */
  color: #3A82FF;
  border: .5px solid #3A82FF;
  padding: 4px 8px;
  /* font-weight: 200; */
   margin-left:10px;
  color: #FFAF30;
  border-color: #FFAF30;
}
// .s4s-title-icon:last-child {
//   /* background-image: linear-gradient(-230deg, #F7B200 0%, #F75A00 100%); */
//   margin-left:10px;
//   color: #FFAF30;
//   border-color: #FFAF30;
// }
/* 3 */
.s4s-index-pic {
  width: 80px;
  height: 50px;
}


.s4s-tit-hd {
  display: flex;
}
.s4s-right {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.s4s-right-txt {
  font-size: 13px;
  color: #aaa;
  display: block;
}
// .s4s-illegal-item {

// }

.s4s-illegal-icon {
  width: 11px;
  height: 15px;
}
.s4s-illegal-addr {
  flex: 1;
  font-size: 14px;
  color: #5b5e6a;
  padding: 0 15px 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.s4s-illegal-btn {
  position: absolute;
  right: 12px;
  bottom: 10px;
  border-top: 1px rgba(0, 0, 0, 0.05) solid;
  padding: 5px 018px;
  border-radius: 2px;
  background-image: linear-gradient(-151deg, #105FF8 0%, #537EFF 100%);
  box-shadow: 1px 1px 3px 0 #D2D2D2;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
  display: flex;
  align-items: center;
}
/*
* author: ernest
* alter content: 车辆轮播
*/
.swiper {
  height: 125px;
  /* transform: scale(0.9); */
  overflow: visible;
  width: 97%;
  margin: 0 auto;
  margin-bottom: 10px;
}

.swiper-item {
  border-radius: 2px;
  /* width: 80%!important; */
  /* margin-right: 10px; */
}
.car-item {
  box-shadow: 0 5px 12px 0 rgba(58,130,255,0.15);
  /* margin-right: 10px; */
  width: 97%;
  margin: 0 auto;
  background-color: #fff;
  /* box-shadow: 0 2px 4px 0 #EFEFEF; */
  border-radius: 2px;
  font-size: 13px;
  height: 96px;
  /* border-right:1px solid #fff; */
}
.car-header {
  background-image: url('../assets/icon/ibg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  color:#fff;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.car-footer {
  background-color: #fff;
  color:#24252D;
  padding: 14px 12px;
  /* justify-content: space-between; */
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.car-footer-num {
  color:#3A82FF;
}
.car-carno {
  font-size: 20px;
  flex: 1;
}
.car-carno-btn {
  font-size: 12px;
  color: #eaf0ff;
}
.car-add {
  padding:12px 0;
  text-align: center;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0 5px 12px 0 rgba(58,130,255,0.15);
  border-radius: 2px;
  border: 1px #3A82FF dashed;

}
.car-add-btn {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: linear-gradient(-133deg, #4162FF 0%, #537EFF 100%);
  font-size: 34px;
  font-weight: 200;
  color: #fff;
  line-height: 34px;
  margin:0 auto;
  text-align: center;
  /* border:1px solid #DDDDDD; */
  margin-bottom: 10px;
}
.car-add-text {
  display: inline-block;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  margin-left: 10px;
  color: #24252d;
}

.s4s-illegal-empty {
  color: #AAAAAA;
  font-size: 14px;
  margin-top: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.s4s-illegal-empty-icon {
  width: 20px;
  height: 20px;
  margin-right:10px;
}
.s4s-illegal-empty-content {
  width: 211px;
  height: 128px;
  margin-bottom: 17px;
}

.s4s-selected {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.s4s-selected-container{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 12px;
  background: #fff;
  border-radius: 2px;
  z-index: 200;
  width: calc(100% - 40px);
}

.s4s-selected-btn-container {
  display: flex;
}

.s4s-selected-btn {
  flex: 1;
  font-size: 12px;
  text-align: center;
  line-height: 21px;
  padding: 11px 0;
}
.s4s-selected-btn:nth-child(2) {
  color:#fff;
  background-image: linear-gradient(-151deg, #105FF8 0%, #537EFF 100%);
}
.s4s-selected-btn:first-child {
  color:#5b5e6a;
  border-top: .5px solid #eaeaea;
  background-color:#fff;
}
.captcha{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
    z-index: 99;

}
.captcha .s4s-mask{
  z-index:0;
}
.captcha-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  background-color: #fff;
  padding:12px;
  border-radius: 5px;
  padding-bottom: 0;
}
.captcha-title{
  color:#333333;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}
.captcha-input:focus ,.captcha-input {
  outline: none;
}
.captcha-input-container {
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.captcha-input-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.captcha-change {
  color:#6F6F6F;
  font-size: 12px;
  margin-bottom: 12.5px;
  text-align: center;
}
.captcha-input {
  min-height: 40px;
  line-height: 40px;
  font-size: 22px;
  color:#333;
  flex: 1;
  width:40px;
  border:1px solid #eaeaea;
  margin-right:10px;
  max-width: 40px;
  text-align: center;
}
.captcha-input:last-child {
  margin-right:0;
}
.captcha-btn {
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  background-image: linear-gradient(40deg, #FF7C00 0%, #FE5A00 100%);
  border-radius: 5px;
  color:#fff;
}
.captcha-keyboard {
  /* display: flex; */
  /* justify-content: space-around; */
  /* flex-wrap: wrap; */
  margin-top: 25px;
}
.captcha-key-list {
  display: flex;
  justify-content: space-around;
  margin:10px;
}
.captcha-key {
  border:none;
  text-align: center;
  color:#24252D;
  font-size: 24px;
  width: 8px;
  height: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.s4s-btn {
  display: block;
  width: 100%;
  margin: 50px 0 12px;
}
</style>
